// extracted by mini-css-extract-plugin
export default {"container":"Register_container__o9VFt","gradientAnimation":"Register_gradientAnimation__MzdH6"};